import AvatarUploadComponent from './AvatarUploadComponent';
export * from './AvatarUploadComponent';
export default AvatarUploadComponent;
